import {
    AlertType,
    DayToCompare,
    DiscrepancyMetrics,
    ExpressionMetric,
    ExpressionOperator,
    Sign,
} from "../../enums";

import {
    IAlert,
    IDeltaParams,
    IDiscrepancyParams,
    IExpressionsParams,
    IThresholdParams,
    DiscrepancyAlertType
} from "@leap4/entities-discrepancy-common";

export const initialThresholdParams: IThresholdParams = {impression: 100, tags: []}
export const initialExpressionParams: IExpressionsParams = {relevantPlatforms: [],windowLoopBack: 0, metric: ExpressionMetric.REVENUE, operator: ExpressionOperator.EQUAL, number:0}
export const initialDeltaParams: IDeltaParams = { relevantPlatforms: [],percent: 0,day_to_compare:DayToCompare.ONE,metric:'revenue',sign:Sign.POSITIVE}
export const initialDiscrepancyParams:IDiscrepancyParams = {relevantPlatforms: [],metric: DiscrepancyMetrics.REVENUE, sign:Sign.BOTH, percent: 0,
    fromDaysAgo: 2, toDaysAgo: 1, type: DiscrepancyAlertType.PUBLISHER_TAG, params:{relevantPlatforms: [],minMetricValueAdServerSide:0, minMetricValuePublisherSide:0}
}

export const initialAlertObj: IAlert = {
    cronExpression:null,
    intervalHour: 0.5,
    lastRun: undefined,
    name: "",
    params: initialExpressionParams,
    type: AlertType.EXPRESSION,
    group: null
}
